
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const navigation = t('navigation', { returnObjects: true }) as Array<{ name: string; href: string }>;
  const contact = t('contact', { returnObjects: true }) as any;

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex flex-col mb-4">
              <span className="text-2xl font-bold bg-gradient-to-br from-amber-700 via-green-600 to-yellow-600 bg-clip-text text-transparent drop-shadow-lg" 
                    style={{ 
                      fontFamily: '"Inter", "Helvetica Neue", sans-serif',
                      letterSpacing: '0.1em',
                      textShadow: '2px 2px 4px rgba(0,0,0,0.15), 1px 1px 2px rgba(139,69,19,0.3)',
                      filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.1))'
                    }}>
                Alpbuild.ch
              </span>
              <div className="text-sm text-green-400 font-medium mt-1" 
                   style={{ fontFamily: '"Inter", "Helvetica Neue", sans-serif' }}>
                Qualité. Fiabilité. Précision suisse.
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Professional construction and renovation services in Switzerland. Quality work with Swiss precision in Vaud and Geneva cantons.
            </p>
            <div className="flex space-x-4">
              {contact?.phone && (
                <a
                  href="tel:+41772184502"
                  className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line text-lg"></i>
                </a>
              )}
              {contact?.email && (
                <a
                  href="mailto:domdavida86@gmail.com"
                  className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                </a>
              )}
              {contact?.whatsapp && (
                <a
                  href="https://wa.me/41772184502"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {Array.isArray(navigation) && navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              {contact?.phone && (
                <div className="flex items-center">
                  <i className="ri-phone-line text-teal-400 mr-3"></i>
                  <span className="text-gray-300">{contact.phone}</span>
                </div>
              )}
              {contact?.email && (
                <div className="flex items-center">
                  <i className="ri-mail-line text-teal-400 mr-3"></i>
                  <span className="text-gray-300">{contact.email}</span>
                </div>
              )}
              {contact?.address && (
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-teal-400 mr-3"></i>
                  <span className="text-gray-300">{contact.address}</span>
                </div>
              )}
              {contact?.workingHours && (
                <div className="flex items-center">
                  <i className="ri-time-line text-teal-400 mr-3"></i>
                  <span className="text-gray-300">{contact.workingHours}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2024 Alpbuild.ch. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}
